import request from "@/utils/request";
const UserbaseUrl = `${process.env.VUE_APP_BASEURL_NEW}/api/v1/admin`;
const UserAuthLoginUrl = `${process.env.VUE_APP_BASEURL_NEW}/api/v1/user`;
const passwordSetupUrl = `${process.env.VUE_APP_PASSWORD_SETUP_SERVICE || "https://dev.online.qqpay.io/userservice"}/api/v1/user/reset-password`;
const AdmindashboardbaseUrl = `${process.env.VUE_APP_BASEURL_NEW}/api/v1/admin-dashboard`;
const dashboardbaseUrl = `${process.env.VUE_APP_BASEURL_NEW}/api/v1/admin_dashboard`;
const rolepermissionUrl = `${process.env.VUE_APP_BASEURL_NEW}/api/v1/role-permission`;
export default {
  // --------------------------------------AUTHENTICATION MODULE----------------------------------//
  Login(userCredentials) {
    return request({
      url: `${UserbaseUrl}/login`,
      method: "POST",
      data: userCredentials, // Make sure this matches what the API expects
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  Createpassword(data) {
    return request({
      url: `${UserbaseUrl}/forget-password`,
      method: "POST",
      data,
    });
  },
  sendCustomerPasswordLink(mobile) {
    return request({
      url: passwordSetupUrl,
      method: "GET",
      params: { mobile },
      timeout: 30000,
    });
  },
  sendCustomerPasswordEmailLink(email) {
    return request({
      url: `${passwordSetupUrl}-email`,
      method: "GET",
      params: { email },
      timeout: 30000,
    });
  },
  TwoFA(User_Email) {
    return request({
      url: `${UserAuthLoginUrl}/forget_password/get_otp/?email=${User_Email}`,
      method: "GET",
    });
  },
  OTPverification(User_Email, otpValue) {
    return request({
      url: `${UserAuthLoginUrl}/forget_password/confirm_otp?email=${User_Email}&otp=${otpValue}`,
      method: "GET",
    });
  },
  verifyOTP(data) {
    return request({
      url: `${UserbaseUrl}/two-step-auth/confirm-otp`,
      method: "POST",
      data,
    });
  },

  getOTP(user_email) {
    return request({
      url: `${UserbaseUrl}/two-step-auth/get-otp?user_email=${user_email}`,
      method: "GET",
    });
  },
  // --------------------------------------ADMIN & PARTNER USER LINK----------------------------------//
  SendPassLink(code) {
    return request({
      url: `${UserbaseUrl}/user-password-link?login_id=${code}`,
      method: "GET",
    });
  },
  // --------------------------------------ADMIN USER----------------------------------//
  PostadminUser(data) {
    return request({
      url: `${UserbaseUrl}/add-user`,
      method: "POST",
      data,
    });
  },
  getAdminuserList() {
    return request({
      url: `${UserbaseUrl}/get-user`,
      method: "GET",
    });
  },
  getAdminuserbyId(id) {
    return request({
      url: `${UserbaseUrl}/user-by-login-id?login_id=${id}`,
      method: "GET",
    });
  },
  UpdateadminUser(params, data) {
    return request({
      url: `${UserbaseUrl}/update-user?login_id=${params}`,
      method: "PUT",
      data,
    });
  },
  userStatusadmin(id, remarks, is_active, data) {
    return request({
      url: `${UserbaseUrl}/update-status?user_id=${id}&remarks=${remarks}&is_active=${is_active}`,
      method: "PUT",
      data,
    });
  },
  // --------------------------------------PARTNER USER----------------------------------//
  PostpartnerUser(data) {
    return request({
      url: `${UserbaseUrl}/add-partner-user`,
      method: "POST",
      data,
    });
  },
  getPartneruserbyId(id) {
    return request({
      url: `${UserbaseUrl}/partner-by-login-id?login_id=${id}`,
      method: "GET",
    });
  },
  UpdatepartnerUser(params, data) {
    return request({
      url: `${UserbaseUrl}/update-partner-user?login_id=${params}`,
      method: "PUT",
      data,
    });
  },
  getPartneruserList() {
    return request({
      url: `${UserbaseUrl}/get-partner-user`,
      method: "GET",
    });
  },
  userStatuspartners(id, is_active, remarks, data) {
    return request({
      url: `${UserbaseUrl}/update-status?user_id=${id}&is_active=${is_active}&remarks=${remarks}`,
      method: "PUT",
      data,
    });
  },

  // --------------------------------------SECURITY 2FA----------------------------------//
  get2FAstatus() {
    return request({
      url: `${UserbaseUrl}/get-two-factor-authentication-status`,
      method: "GET",
    });
  },
  updateTwoFactorAuth(user_type, auth, data) {
    return request({
      url: `${UserbaseUrl}/update-two-set-authentication?user_type=${user_type}&is_two_step_authentication=${auth}`,
      method: "PUT",
      data,
    });
  },

  //---------------------------------------INDIVIDUAL USER----------------------------------//
  addIndCustomer(data) {
    return request({
      url: `${UserbaseUrl}/add-ind-customer`,
      method: "POST",
      data,
    });
  },
  //---------------------------------------LOGS----------------------------------//

  //-----------------AUDIT LOGS-----------//
  getAdminuserlog(params) {
    return request({
      url: `${UserbaseUrl}/admin-audit-logs-data`,
      method: "GET",
      params: params,
    });
  },
  getCustomeruserlog(params) {
    return request({
      url: `${UserbaseUrl}/customer-audit-logs-data`,
      method: "GET",
      params: params,
    });
  },
  getTranscationAduitlog(params) {
    return request({
      url: `${UserbaseUrl}/transaction-audit-logs`,
      method: "GET",
      params: params,
    });
  },
  //-----------------API LOGS-----------//
  getApilog(params) {
    return request({
      url: `${UserbaseUrl}/api-logs-data`,
      method: "GET",
      params: params,
    });
  },
  //-----------------ERROR LOGS-----------//
  getErrorlog(params) {
    return request({
      url: `${UserbaseUrl}/error-logs-data`,
      method: "GET",
      params: params,
    });
  },
  //-----------------INTEGRATION LOGS-----------//
  getIntegrationlog(params) {
    return request({
      url: `${UserbaseUrl}/integration-logs`,
      method: "GET",
      params: params,
    });
  },
  //-----------------LOGIN LOGS-----------//
  getLoginlog(params) {
    return request({
      url: `${UserbaseUrl}/login-logs`,
      method: "GET",
      params: params,
    });
  },
  //-----------------TRANSCATION LOGS-----------//
  getTransctionlog(params) {
    return request({
      url: `${UserbaseUrl}/transaction-logs`,
      method: "GET",
      params: params,
    });
  },
  //-----------------LOCKED CUSTOMER LOGS-----------//
  getLockedCustomerslog(params) {
    return request({
      url: `${UserbaseUrl}/get-locked-customers`,
      method: "GET",
      params: params,
    });
  },
  //-----------------LOCKED CUSTOMER LIST LOGS-----------//
  getLockedcustlistlog(params) {
    return request({
      url: `${UserbaseUrl}/locked-customer-logs`,
      method: "GET",
      params: params,
    });
  },
  //-----------------LOCKED LOGS-----------//
  getLockeduserslog(params) {
    return request({
      url: `${UserbaseUrl}/locked-user-logs`,
      method: "GET",
      params: params,
    });
  },
  //-------------------------------PROFILE-----------------------------------------//
  getremitteById(params) {
    return request({
      url: `${UserbaseUrl}/customer-profile-by-id?`,
      method: "GET",
      params: params,
    });
  },
  //--------------------------------------LOCKED CUSTOMMERS----------------------------------//
  updateLockedCustms(id, is_locked, remarks, data) {
    return request({
      url: `${UserbaseUrl}/unlock-customer?user_id=${id}&lock_status=${is_locked}&remarks=${remarks}`,
      method: "PUT",
      data,
    });
  },
  //-------------------------------------DASHBOARD BASE------------------------------------//

  getAllUsers() {
    return request({
      url: `${AdmindashboardbaseUrl}/no-of-customers`,
      method: "GET",
    });
  },
  getAllTrans() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-transactions`,
      method: "GET",
    });
  },
  getTransAmt() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-transactions-amount`,
      method: "GET",
    });
  },
  getPendTrans() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-non-pushed-txns`,
      method: "GET",
    });
  },
  getPendingCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-non-pushed-customers`,
      method: "GET",
    });
  },
  getAllPartners() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-partners`,
      method: "GET",
    });
  },
  getTotalComplianceHold() {
    return request({
      url: `${AdmindashboardbaseUrl}/no-of-compliance-hold`,
      method: "GET",
    });
  },
  getTotalEmpUsers() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-emp-users`,
      method: "GET",
    });
  },
  getAllIndUsers() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-ind-users`,
      method: "GET",
    });
  },
  getAllBUSusers() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-bus-users`,
      method: "GET",
    });
  },
  getAllTransactions() {
    return request({
      url: `${AdmindashboardbaseUrl}/total-transactions-data`,
      method: "GET",
    });
  },
  getTodayUsers() {
    return request({
      url: `${AdmindashboardbaseUrl}/today-total-transactions-data`,
      method: "GET",
    });
  },
  getTotalCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/all-customer-details`,
      method: "GET",
    });
  },
  getTodayRegCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/list-of-today-reg-user-details`,
      method: "GET",
    });
  },
  getTotalINDCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/all-ind-customer-details`,
      method: "GET",
    });
  },
  getTotalBUSCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/all-bus-customer-details`,
      method: "GET",
    });
  },
  getTotalRejectCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/rejected-customer-details`,
      method: "GET",
    });
  },
  getINDRejectCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/rejected-ind-customer-details`,
      method: "GET",
    });
  },
  getBUSRejectCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/rejected-ind-customer-details`,
      method: "GET",
    });
  },
  getApprovedCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/approved-customer-details`,
      method: "GET",
    });
  },
  getApprovedINDCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/approved-ind-customer-details`,
      method: "GET",
    });
  },
  getApprovedBUSCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/approved-bus-customer-details`,
      method: "GET",
    });
  },
  getAllHoldCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/hold-customer-details`,
      method: "GET",
    });
  },
  getINDHoldCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/hold-ind-customer-details`,
      method: "GET",
    });
  },
  getBUSHoldCustomers() {
    return request({
      url: `${AdmindashboardbaseUrl}/hold-bus-customer-details`,
      method: "GET",
    });
  },
  getTotalPartners() {
    return request({
      url: `${AdmindashboardbaseUrl}/list-of-reg-partner-details`,
      method: "GET",
    });
  },
  getTodayPartners() {
    return request({
      url: `${AdmindashboardbaseUrl}/list-of-today-reg-partner-details`,
      method: "GET",
    });
  },
  //-------------------------------COMPLIENCE BASE-----------------------------------------//
  getRemittenceList(params) {
    return request({
      url: `${UserbaseUrl}/get-filter-data`,
      method: "GET",
      params: params,
    });
  },
  getTotalTrans() {
    return request({
      url: `${dashboardbaseUrl}/list-of-all-transactions`,
      method: "GET",
    });
  },
  getTodayTrans() {
    return request({
      url: `${dashboardbaseUrl}/list-of-transactions-by-current-date`,
      method: "GET",
    });
  },
  getTransHold() {
    return request({
      url: `${dashboardbaseUrl}/all-hold-transactions-data`,
      method: "GET",
    });
  },
  getTransCancel() {
    return request({
      url: `${dashboardbaseUrl}/all-cancel-transactions-data`,
      method: "GET",
    });
  },
  //-------------------------------KYC-----------------------------------------//
  getIndKYC(params) {
    return request({
      url: `${UserbaseUrl}/customer-kyc-summery?login_id=`,
      method: "GET",
      params,
    });
  },
  profileUpdateIND(id, data) {
    return request({
      url: `${UserbaseUrl}/update-kyc-details?login_id=${id}`,
      method: "PUT",
      data,
    });
  },
  prfileKYCstatus(id, kyc_status, remarks) {
    return request({
      url: `${UserbaseUrl}/kyc-status?login_id=${id}&KycStatus=${kyc_status}&remarks=${remarks}`,
      method: "PUT",
    });
  },
  updateKYCstatus(id, kyc_status, remarks) {
    return request({
      url: `${UserbaseUrl}/update-kyc-status?login_id=${id}&kyc_status=${kyc_status}&remarks=${remarks}`,
      method: "PUT",
    });
  },
  //-------------------------------PROFILE-----------------------------------------//
  fileChange(id, data) {
    return request({
      url: `${UserbaseUrl}/profile/upload?login_id=${id}`,
      method: "POST",
      data,
    });
  },
  getRemittenceId(params) {
    return request({
      url: `${UserbaseUrl}/customer-profile-by-id?`,
      method: "GET",
      params,
    });
  },
  profileUpdate(id, data) {
    return request({
      url: `${UserbaseUrl}/update-ind-customer?login_id=${id}`,
      method: "PUT",
      data,
    });
  },
  profileStatus(id, user_status) {
    return request({
      url: `${UserbaseUrl}/update-user-status?login_id=${id}&user_status=${user_status}`,
      method: "PUT",
    });
  },

  //-------------------------------PUSH CUSTOMER LIST-----------------------------------------//
  getPushCustomerlist(code) {
    return request({
      url: `${UserbaseUrl}/get-non-pushed-customers?today=${code}`,
      method: "GET",
    });
  },
  getPushCustomersByDate(from_date,to_from) {
    return request({
      url: `${UserbaseUrl}/get-non-pushed-customers-by-date?from_date=${from_date}&to_date=${to_from}`,
      method: "GET",
    });
  },
  getCustomerlogst(code) {
    return request({
      url: `${UserbaseUrl}/download-customer-logs?user_id=${code}`,
      method: "GET",
    });
  },
  //-------------------------------Compliance Hold List----------------------------------------//
  getALlDepositeChannel() {
    return request({
      url: `${UserbaseUrl}/get-compliance-hold-summary`,
      method: "GET",
    });
  },
  getAllsanctionCustomer() {
    return request({
      url: `${UserbaseUrl}/get-compliance-hold-customers`,
      method: "GET",
    });
  },
  updateSanctionCust(item) {
    return request({
      url: `${UserbaseUrl}/compliance-status?customer_id=${item.id}&release_status=${item.status}&remarks=${item.remarks}`,
      method: "PUT",
    });
  },

  //-----------------------------------Roles------------------------------------------------//

  getAllRoles() {
    return request({
      url: `${rolepermissionUrl}/roles/?skip=0&limit=10000000`,
      method: "GET",
    });
  },
  getALlRoleById(id) {
    return request({
      url: `${rolepermissionUrl}/roles/${id}`,
      method: "GET",
    });
  },
  addRoleData(data) {
    return request({
      url: `${rolepermissionUrl}/roles/`,
      method: "POST",
      data
    });
  },
  updateRoleData(id,data) {
    return request({
      url: `${rolepermissionUrl}/roles/${id}`,
      method: "PUT",
      data
    });
  },
  deleteRole(id) {
    return request({
      url: `${rolepermissionUrl}/roles/${id}`,
      method: "DELETE",
    });
  },

   //--------------------------------------------Modules Of Rules-----------------------------------//
   getAllRoleModules(limit) {
    return request({
      url: `${rolepermissionUrl}/list-module/?skip=0&limit=${limit}`,
      method: "GET",
    });
  },

  getRoleById(id) {
    return request({
      url: `${rolepermissionUrl}/module/${id}`,
      method: "GET",
    });
  },
  postRoleModule(data) {
    return request({
      url: `${rolepermissionUrl}/module/`,
      method: "POST",
      data
    });
  },
  updateRoleModule(id,data) {
    return request({
      url: `${rolepermissionUrl}/module/${id}`,
      method: "PUT",
      data
    });
  },
  deleteRoleModule(id) {
    return request({
      url: `${rolepermissionUrl}/module/${id}`,
      method: "DELETE",
    });
  },
   //--------------------------------------------Sub Modules Of Rules-----------------------------------//
   getAllSubModules(id) {
    return request({
      url: `${rolepermissionUrl}/sub-module-by-module-id/${id}`,
      method: "GET",
    });
  },
  getSubModuleById(id) {
    return request({
      url: `${rolepermissionUrl}/sub-module/${id}`,
      method: "GET",
    });
  },
  postSubModule(data) {
    return request({
      url: `${rolepermissionUrl}/sub-module/`,
      method: "POST",
      data
    });
  },
  updateSubModule(id,data) {
    return request({
      url: `${rolepermissionUrl}/sub-module/${id}`,
      method: "PUT",
      data
    });
  },
  deleteSubModule(id) {
    return request({
      url: `${rolepermissionUrl}/sub-module/${id}`,
      method: "DELETE",
    });
  },
  //-----------------------------Previliges Roles---------------------------------------------//
  getSubModulesByRole(id) {
    return request({
      url: `${rolepermissionUrl}/modules-permissions/${id}`,
      method: "GET",
    });
  },
  updateSubModulesByRole(id,data) {
    return request({
      url: `${rolepermissionUrl}/update-role-permissions/${id}`,
      method: "PUT",
      data
    });
  },
  //-------------------------------COMPLIANCE TXN HOLD----------------------------------------//

  getCopmlianceMatching(id) {
    return request({
      url: `${UserbaseUrl}/get-compliance-txn-data?pin_number=${id}`,
      method: "GET",
    });
  },
};
